import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/my/advances/$advanceId',
}).lazy(() => import('./$advanceId.index.lazy').then((d) => d.Route))
